import lity from 'lity';
jQuery(document).ready(function ($) {
    var dom = $('.newsletter-signup');
    var newsletter = {
        'dom': dom,
        'opener': $('.j-footer--newsletter'),
        'email': '',
        'popup': '',
        'uuid': '',
        'inputs': {
            'email': dom.find('.input--email'),
            'first': dom.find('.input--first-name'),
            'last': dom.find('.input--last-name'),
//            'role': dom.find('.input--role'),
            'newsletter': dom.find('.input--newsletter'),
            'privacy': dom.find('.input--privacy'),
            'submit': dom.find('.newsletter-signup--submit'),
            'country':  dom.find('.newsletter_assessment_country')
        },
        'gaconnector': {
            'all_traffic_sources': '',
            'fc_campaign': '',
            'fc_channel': '',
            'fc_content': '',
            'fc_landing': '',
            'fc_medium': '',
            'fc_referrer': '',
            'fc_source': '',
            'fc_term': '',
            'GA_Client_ID': '',
            'lc_campaign': '',
            'lc_channel': '',
            'lc_content': '',
            'lc_landing': '',
            'lc_medium': '',
            'lc_referrer': '',
            'lc_source': '',
            'lc_term': '',
            'page_visits': '',
            'time_passed': '',
            'device': '',
            'OS': '',
            'browser': '',
            'latitude': '',
            'longitude': ''
        },
        "values": {
            "Email": "",
            // "FirstName": "",
            // "LastName": "",
            "OPT-IN": "",
            "RoleInJourney": "",
            "timezone": ""
        },
        open: function () {
            this.resetForm();
            this.getEmail();
            this.setEmail();
            //this.dom.addClass('visible');
            this.popup = lity(this.dom);

            // Submit GTM tag of start guide download popup
            this.submitGTM('guide-download-open','Guide Download Start Location', window.location.href );

            //this is because there are two lity pop ups on the same page.
            var closeButton = document.querySelector('.lity-close');
            if (closeButton) {
                closeButton.style.display = 'none';
            }
        },
        resetForm: function () {
            this.inputs.first.val('');
            this.inputs.last.val('');
//            this.inputs.role.find(':checked').prop('checked', false);
            this.inputs.newsletter.find('input').prop('checked', false);
            this.inputs.privacy.find(':checked').prop('checked', false);
            this.checkPrivacy();
            this.dom.find('.has-error').removeClass('has-error');
        },
        getEmail: function () {
            this.email = this.opener.find('input').val();
        },
        setEmail: function () {
            this.inputs.email.val(this.email);
        },
        close: function () {
            this.popup.close();
            //this.dom.removeClass('visible');
        },
        getTimezone: function (date) {
            return /\((.*)\)/.exec(date.toString())[1];
        },
        submitForm: function () {
            this.gatherData();
            this.gatherGAConnector();

            if (this.validateForm()) {
                this.submitResults();

                // Submit GTM tag of start guide download popup
                this.submitGTM('guide-download-form-complete','Guide Download Form Complete', window.location.href );
            }
        },
        gatherData: function () {
            this.values.Email = this.inputs.email.val().trim();
            this.values['First Name'] = this.inputs.first.val();
            this.values['Last Name'] = this.inputs.last.val();
            this.values['Country'] = this.inputs.country.val();
            //this.values.RoleInJourney = this.inputs.role.find(':checked').val();
            this.values.RoleInJourney = "";
            this.values['OPT-IN'] = ( this.inputs.newsletter.find(':checked').val() === "true" ) ? 1 : 0;
            this.values.privacy = this.inputs.privacy.find(':checked').val();
            this.values.timezone = this.getTimezone(new Date());
        },
        gatherGAConnector: function() {
            // this.gaconnector.all_traffic_sources = document.getElementsByName("all_traffic_sources")[0].value;
            this.gaconnector.all_traffic_sources = this.dom.find("input[name='all_traffic_sources']").val();
            this.gaconnector.fc_campaign = this.dom.find("input[name='fc_campaign']").val();
            this.gaconnector.fc_channel = this.dom.find("input[name='fc_channel']").val();
            this.gaconnector.fc_content = this.dom.find("input[name='fc_content']").val();
            this.gaconnector.fc_landing = this.dom.find("input[name='fc_landing']").val();
            this.gaconnector.fc_medium = this.dom.find("input[name='fc_medium']").val();
            this.gaconnector.fc_referrer = this.dom.find("input[name='fc_referrer']").val();
            this.gaconnector.fc_source = this.dom.find("input[name='fc_source']").val();
            this.gaconnector.fc_term = this.dom.find("input[name='fc_term']").val();
            this.gaconnector.GA_Client_ID = this.dom.find("input[name='GA_Client_ID']").val();
            this.gaconnector.lc_campaign = this.dom.find("input[name='lc_campaign']").val();
            this.gaconnector.lc_channel  = this.dom.find("input[name='lc_channel']").val();
            this.gaconnector.lc_content = this.dom.find("input[name='lc_content']").val();
            this.gaconnector.lc_landing = this.dom.find("input[name='lc_landing']").val();
            this.gaconnector.lc_medium = this.dom.find("input[name='lc_medium']").val();
            this.gaconnector.lc_referrer = this.dom.find("input[name='lc_referrer']").val();
            this.gaconnector.lc_source = this.dom.find("input[name='lc_source']").val();
            this.gaconnector.lc_term = this.dom.find("input[name='lc_term']").val();
            this.gaconnector.page_visits = this.dom.find("input[name='page_visits']").val();
            this.gaconnector.time_passed = this.dom.find("input[name='time_passed']").val();
            this.gaconnector.OS = this.dom.find("input[name='OS']").val();
            this.gaconnector.browser = this.dom.find("input[name='browser']").val();
            this.gaconnector.latitude = this.dom.find("input[name='latitude']").val();
            this.gaconnector.longitude = this.dom.find("input[name='longitude']").val();
            this.gaconnector.device = this.dom.find("input[name='device']").val();
        },
        validateForm: function () {
            var isValid = true;
            if(!this.validateNameFields()){
               isValid = false;
            }
            if (!this.validateEmail()) {
                isValid = false;
            }
            if (!this.validateRole()) {
                isValid = false;
            }
            if (!this.validatePrivacyField()) {
                isValid = false;
            }
            return isValid;
        },
        checkPrivacy: function () {
            newsletter.gatherData();
            if (this.validatePrivacyField() && this.validateNewsletterField()) {
                this.inputs.submit.prop('disabled', false);
            }
            else {
                this.inputs.submit.prop('disabled', true);
            }
        },
        submitResults: function () {
            newsletter.dom.find('#newsletter-signup--submit').prop('disabled', true).addClass('o-ajax-progress');

            let values = {
                "Email": this.values.Email,
                "FirstName": this.values["First Name"],
                "LastName": this.values["Last Name"],
                "OPT-IN": this.values["OPT-IN"],
                "Country": this.values["Country"],
                "Privacy": this.values.privacy,
                "Patient_Time_zone__c": this.values.timezone,
                "All_Traffic_Sources__c": this.gaconnector.all_traffic_sources,
                "gaconnector_First_Click_Campaign__c": this.gaconnector.fc_campaign,
                "gaconnector_First_Click_Channel__c": this.gaconnector.fc_channel,
                "gaconnector_First_Click_Content__c": this.gaconnector.fc_content,
                "gaconnector_First_Click_Landing_Page__c": this.gaconnector.fc_landing,
                "gaconnector_First_Click_Medium__c": this.gaconnector.fc_medium,
                "gaconnector_First_Click_Referrer__c": this.gaconnector.fc_referrer,
                "gaconnector_First_Click_Source__c": this.gaconnector.fc_source,
                "gaconnector_First_Click_Term__c": this.gaconnector.fc_term,
                "gaconnector_Google_Analytics_Client_ID__c": this.gaconnector.GA_Client_ID,
                "gaconnector_Last_Click_Campaign__c": this.gaconnector.lc_campaign,
                "gaconnector_Last_Click_Channel__c": this.gaconnector.lc_channel,
                "gaconnector_Last_Click_Content__c": this.gaconnector.lc_content,
                "gaconnector_Last_Click_Landing_Page__c": this.gaconnector.lc_landing,
                "gaconnector_Last_Click_Medium__c": this.gaconnector.lc_medium,
                "gaconnector_Last_Click_Referrer__c": this.gaconnector.lc_referrer,
                "gaconnector_Last_Click_Source__c": this.gaconnector.lc_source,
                "gaconnector_Last_Click_Term__c": this.gaconnector.lc_term,
                "gaconnector_Number_of_Website_Visits__c": this.gaconnector.page_visits,
                "gaconnector_Time_Spent_on_Website__c": this.gaconnector.time_passed,
                "gaconnector_Operating_System__c": this.gaconnector.OS,
                "gaconnector_Browser__c": this.gaconnector.browser,
                "gaconnector_Latitude_from_IP__c": this.gaconnector.latitude,
                "gaconnector_Longitude__c": this.gaconnector.longitude,
                "Device__c": this.gaconnector.device
            };


            jQuery.ajax({
                method: "POST",
                url: ajaxURL,
                data: {
                    'action': 'submit_salesforce_form',
                    'nonce': ajaxNonce,
                    'form': values,
                    'form_type': 'more-info'
                },
                success: function (rawhtml) {
                    newsletter.dom.addClass('form-complete');
                }
            });
        },
        // validation ___________________///
        validateNameFields: function () {
            var result = true;
            if (this.values['First Name'].length < 1) {
                result = false;
                this.inputs.first.parents('.gfield').addClass('has-error');
            } else {
                this.inputs.first.parents('.gfield').removeClass('has-error');
            }

            if (this.values['Last Name'].length < 1) {
                result = false;
                this.inputs.last.parents('.gfield').addClass('has-error');
            } else {
                this.inputs.last.parents('.gfield').removeClass('has-error');
            }
            return result;
        },

        validateEmail: function () {
            var result = true;

            var error_code = this.testEmail(this.values.Email);

                        var error_message = '';

            switch(error_code) {
                case 0:
                    error_message = 'Email address required';
                    break;
                case -1:
                    error_message = 'An @ sign is required';
                    break;
                case 1:
                    error_message = 'Please remove whitespace';
                    break;
                default:
                    error_message = 'Please enter a valid email address';
            }

            if (error_code <= 1) {
                result = false;
                this.inputs.email.parents('.gfield').addClass('has-error');
                this.dom.find("label[for='ns_input_2_3'] > span").text(error_message);
            }else{
                this.inputs.email.parents('.gfield').removeClass('has-error');
            }
            return result;
        },

        validateRole: function () {
            var result = true;
        //  if (typeof this.values.RoleInJourney === "undefined") {
        //      result = false;
        //      this.inputs.role.parents('.gfield').addClass('has-error');
        //  } else {
        //      this.inputs.role.parents('.gfield').removeClass('has-error');
        //  }
            return result;
        },

        validatePrivacyField: function () {
            var result = true;
            if (this.values.privacy !== "true") {
                result = false;
                this.inputs.privacy.parents('.gfield').addClass('has-error');
            } else {
                this.inputs.privacy.parents('.gfield').removeClass('has-error');
            }
            return result;
        },
        validateNewsletterField: function () {
            var result = true;
            if (this.values["OPT-IN"] !== 1) {
                result = false;
                this.inputs.newsletter.parents('.gfield').addClass('has-error');
            } else {
                this.inputs.newsletter.parents('.gfield').removeClass('has-error');
            }
            return result;
        },
        testEmail: function (email) {
            var error_code = '';

            if (email.length === 0) {
                error_code = 0;
                console.log(error_code);
                return error_code;
            }

            if (email.indexOf('@') === -1) {
                error_code = email.indexOf('@');
                return error_code;
            }

            if (email.indexOf(' ') !== -1) {
              error_code = 1;
              return error_code;
            }

            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

            if (!re.test(email)) {
                error_code = -2;
                return error_code;
            }
        },

        submitGTM: function (pageSlug, pageName, locationURL) {
            if (newsletter.uuid.length < 1) {
                newsletter.uuid = window.getCookie('visitorUUID');
            }
            dataLayer.push({
                'event': 'VirtualPageview',
                'virtualPageURL': '/guide-download/' + pageSlug,
                'virtualPageTitle': pageName,
                'answer': locationURL,
                'UUID': newsletter.uuid
            });
        }
    };

    /// ACTIONS
    newsletter.opener.on('click', '.j-newsletter-signup--open', function () {
        newsletter.open();
    });
    $(document).on('click', 'a[href="#download"]', function () {
        newsletter.open();
      });
    newsletter.opener.on('keyup', 'input', function (event) {
        if (event.keyCode === 13) {
            newsletter.open();
        }
    });
    newsletter.dom.on('click', '.newsletter-signup--close', function () {
        newsletter.close();
    });
    newsletter.inputs.privacy.on('click', function () {
        newsletter.checkPrivacy();
    });
    newsletter.inputs.newsletter.on('click', function () {
        newsletter.checkPrivacy();
    });

    newsletter.dom.on('click', '#newsletter-signup--submit', function (e) {
        e.preventDefault();
        newsletter.submitForm();
    });
});
